module.exports = function displaySocialMediaOnContent() {
        const socialMediaBar = require('../includes/social-bar-on-content.html');
        $('.meta').append(socialMediaBar);
};


// WEBPACK FOOTER //
// ./scriptPartials/socialMediaOnContent.js